(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wallpaper-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    const calculate = (widthValue, heightValue, unitPriceCents) => {
      if (widthValue === '' || heightValue === '') return null;

      const width = Number(widthValue);
      const height = Number(heightValue);
      const price = Number(unitPriceCents);

      if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
      if (!Number.isFinite(price) || price < 0) return null;

      const actualArea = Number(((width / 100) * (height / 100)).toFixed(4));
      const chargedArea = Math.max(1, Math.ceil(actualArea));

      return {
        actualArea,
        chargedArea,
        totalCents: chargedArea * price,
      };
    };

    const formatButtonPrice = (totalCents, unitPriceLabel, locale, currency) => {
      if (totalCents === null) return unitPriceLabel;

      return new Intl.NumberFormat(locale || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      }).format(totalCents / 100);
    };

    globalThis.WallpaperCalculatorMath = { calculate, formatButtonPrice };

    if (typeof HTMLElement === 'undefined' || typeof customElements === 'undefined') return;

    class WallpaperCalculator extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.widthInput = this.querySelector('[data-wallpaper-width]');
        this.heightInput = this.querySelector('[data-wallpaper-height]');
        this.chargedOutput = this.querySelector('[data-wallpaper-charged]');
        this.totalOutput = this.querySelector('[data-wallpaper-total]');
        this.actualProperty = this.querySelector('[data-wallpaper-actual-property]');
        this.chargedProperty = this.querySelector('[data-wallpaper-charged-property]');
        this.quantityInput = this.form?.querySelector('input[name="quantity"]');
        this.submitButton = this.form?.querySelector('[data-add-to-cart]');
        this.submitText = this.submitButton?.querySelector('[data-add-to-cart-text]');
        this.areaUnit = this.dataset.areaUnit;
        this.unitPriceLabel = this.dataset.unitPriceLabel;
        this.currentButtonPrice = this.unitPriceLabel;

        if (!this.form || !this.widthInput || !this.heightInput || !this.quantityInput || !this.submitButton || !this.submitText || !this.areaUnit || !this.unitPriceLabel) return;

        this.widthInput.addEventListener('input', () => this.update());
        this.heightInput.addEventListener('input', () => this.update());
        this.buttonObserver = new MutationObserver(() => this.renderButtonPrice());
        this.buttonObserver.observe(this.submitText, { childList: true, subtree: true, characterData: true });
        this.update();
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
      }

      renderButtonPrice() {
        const price = this.submitButton.querySelector('.btn__price');
        if (price && price.textContent.trim() !== this.currentButtonPrice) {
          price.textContent = this.currentButtonPrice;
        }
      }

      update() {
        const result = calculate(this.widthInput.value, this.heightInput.value, this.dataset.priceCents);

        if (!result) {
          this.chargedOutput.textContent = '\u2014';
          this.totalOutput.textContent = '\u2014';
          this.actualProperty.value = '';
          this.chargedProperty.value = '';
          this.quantityInput.value = '1';
          this.currentButtonPrice = formatButtonPrice(
            null,
            this.unitPriceLabel,
            this.dataset.locale,
            this.dataset.currency
          );
          this.renderButtonPrice();
          this.submitButton.disabled = true;
          return;
        }

        const formattedTotal = formatButtonPrice(
          result.totalCents,
          this.unitPriceLabel,
          this.dataset.locale,
          this.dataset.currency
        );

        this.chargedOutput.textContent = `${result.chargedArea} ${this.areaUnit}`;
        this.totalOutput.textContent = formattedTotal;
        this.currentButtonPrice = formattedTotal;
        this.renderButtonPrice();
        this.actualProperty.value = `${result.actualArea.toFixed(2)} ${this.areaUnit}`;
        this.chargedProperty.value = `${result.chargedArea} ${this.areaUnit}`;
        this.quantityInput.value = String(result.chargedArea);
        this.submitButton.disabled = this.dataset.available !== 'true';
      }
    }

    if (!customElements.get('wallpaper-calculator')) {
      customElements.define('wallpaper-calculator', WallpaperCalculator);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
